import { myinfo, updateprofile, userinfo, unsubscribe, requestConsent, clientInfo } from '../api'
import { getUser, saveUser } from '../../services/authService'

export const getUserFromLocalStorage = ({ commit }, data) => {
  return getUser(data).then((res) => {
    commit('MYINFO', res)
    return res
  }).catch((err) => {
    return err
  })
}

export const getMe = async ({ commit }, data) => {
  try {
    const res = await myinfo()
    await saveUser('user', res.data)
    commit('MYINFO', res.data)
    return res.data
  } catch (err) {
    console.log(err)
    return err
  }
}

export const getUserInfo = ({ commit }, data) => {
  commit('USERID', data)
  return userinfo(data).then((res) => {
    return res.data
  }).catch((err) => {
    console.log(err)
  })
}

export const doProfileUpdate = ({ commit, state }, data) => {
  console.log('data', data)
  return updateprofile(data, state.myInfo._id).then((res) => {
    commit('MYINFO', res.data)
    commit('TOAST_ACCOUNT', 'Successfuly updated!')
    return res.data
  }).catch((err) => {
    console.log(err)
    commit('TOAST_ACCOUNT', err)
  })
}

export const doUserUpdate = ({ commit, state }, data) => {
  return updateprofile(data, state.clientId).then((res) => {
    commit('CLIENT_INFO', res.data)
    commit('TOAST_USER', 'Successfuly updated!')
    return res.data
  }).catch((err) => {
    console.log(err)
  })
}

export const doUnsubscribe = ({ commit, state }, data) => {
  return unsubscribe(state.myInfo._id).then((res) => {
    return res.data
  }).catch((err) => {
    console.log(err)
    commit('TOAST_ACCOUNT', err)
  })
}

export const doRequestConsent = async ({ commit, state }, data) => {
  try {
    const res = await requestConsent(data)
    return res.data
  } catch (err) {
    console.log(err)
  }
}

export const getClient = async ({ commit, getters }) => {
  try {
    const clientId = getters.getClientId
    const res = await clientInfo(clientId)
    commit('CLIENT_INFO', res.data)
    return res.data
  } catch (err) {
    console.log(err)
    return err
  }
}

export const setClientId = async ({ commit }, data) => {
  try {
    commit('CLIENT_ID', data)
  } catch (err) {
    console.log(err)
    return err
  }
}



// WEBPACK FOOTER //
// ./src/app/store/profile/actions.js